import { ReactNode } from "react";
import { Navigate, useSearchParams } from "react-router-dom";

export const InviteProtectedLayout = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  const name = searchParams.get("name");

  if (!email || !name) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
